export default "__VITE_ASSET__4c692ce1__"